import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { useExtraConfigContext } from '@gov-nx/core/app';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { ContentLayout, LayoutGap } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';

export const DataBoxMessageDetailPageSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	const { extraConfig } = useExtraConfigContext();

	return (
		<ContentLayout customClasses="flex flex-col justify-between h-full rounded-2xl">
			<LayoutGap className="px-4 [ md:px-0 ] overflow-hidden">
				<GovSkeleton
					width="80px"
					height="20px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
					className="[ md:hidden! ]"
				/>
				<div className="flex flex-col gap-1 [ md:flex-row md:justify-between md:items-center md:flex-wrap ]">
					<GovSkeleton
						width="315px"
						height="26px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width="115px"
						height="20px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<div className="flex flex-col gap-1">
					<GovSkeleton
						width={generateRandomNumber(40, 80) + '%'}
						height="24px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width={generateRandomNumber(40, 80) + '%'}
						height="24px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<GovSkeleton
					width="145px"
					height="24px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
				<div className="flex flex-col gap-4 pt-6 border-t border-(--border-subtlest) [ md:flex-row md:flex-wrap ]">
					<GovSkeleton
						width="265px"
						height="65px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width="265px"
						height="65px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<GovSkeleton
					width="235px"
					height="24px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</LayoutGap>
			<LayoutGap className="flex-row! justify-between items-center pt-6 px-4 border-t border-(--border-subtlest) [ md:px-0 ]">
				<GovSkeleton
					width="174px"
					height="30px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
				{extraConfig.pageRoutes.databoxConfig.displayArchiveAction && (
					<GovSkeleton
						width="30px"
						height="30px"
						shape="circle"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				)}
				<GovSkeleton
					width="90px"
					height="22px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
					className="ml-auto!"
				/>
			</LayoutGap>
		</ContentLayout>
	);
};
